var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50903 18.0024V18.5147C9.50903 19.1751 9.77154 19.8085 10.2388 20.2754C10.706 20.7422 11.3396 21.0042 12.0001 21.0037V21.0037C12.6606 21.004 13.2943 20.7417 13.7614 20.2747C14.2286 19.8077 14.4911 19.1742 14.4911 18.5137V18.0024",
    stroke: "#7F56D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9496 18.0025C19.084 18.0025 20.0035 17.0829 20.0035 15.9486V15.9486C20.003 15.3724 19.7742 14.8198 19.3672 14.412L18.0027 13.0484V8.99872C18.0027 5.68363 15.3152 2.99622 12.0002 2.99622V2.99622C8.68507 2.99622 5.99766 5.68363 5.99766 8.99872V13.0484L4.63309 14.412C4.22608 14.8198 3.99729 15.3724 3.99683 15.9486V15.9486C3.99683 16.4933 4.21321 17.0157 4.59839 17.4009C4.98356 17.7861 5.50597 18.0025 6.05068 18.0025H17.9496Z",
    stroke: "#7F56D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell_icon.35ad3b77d1604227a015b82f6c19a330.svg";
export { ForwardRef as ReactComponent };